import { g as getInputId } from './getInputId-aa144169.js';

function getLabelId(name, baseId) {
  return getInputId(name, baseId, "-label");
}

export { getLabelId as g };
